import { render, staticRenderFns } from "./BFlowStartProps.vue?vue&type=template&id=73448c26&scoped=true"
import script from "./BFlowStartProps.vue?vue&type=script&lang=js"
export * from "./BFlowStartProps.vue?vue&type=script&lang=js"
import style0 from "./BFlowStartProps.vue?vue&type=style&index=0&id=73448c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73448c26",
  null
  
)

export default component.exports